import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, input, viewChild } from '@angular/core';
import { AccountGroup } from '../../../domain/account.domain';

export enum AccountGroupLabelType {
  SHORT = 'short',
  LONG = 'long'
}

@Component({
  selector: 'td-wb-account-group-label',
  templateUrl: 'account-group-label.component.html',
  styleUrls: ['account-group-label.component.scss'],
  imports: [
    NgTemplateOutlet
  ]
})
export class AccountGroupLabelComponent {

  readonly accountGroup = input<AccountGroup>(undefined);
  readonly type = input<AccountGroupLabelType>(AccountGroupLabelType.LONG);
  readonly shortLabelTemplate = viewChild<TemplateRef<unknown>>('shortLabelTemplate');
  readonly longLabelTemplate = viewChild<TemplateRef<unknown>>('longLabelTemplate');

  constructor() {
  }

  getTemplate(): TemplateRef<unknown> {
    switch (this.type()) {
      case(AccountGroupLabelType.SHORT):
        return this.shortLabelTemplate();
      case AccountGroupLabelType.LONG:
        return this.longLabelTemplate();
      default:
        return this.longLabelTemplate();
    }
  }
}
